/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environments';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../../services/authentication.service';
import { SharedModule } from '../../shared/shared.moudle';
import { PasswordStrengthComponent } from '../password-strength/password-strength.component';
import { LoaderService } from '../../../services/loader.service';
import { PASSWORD_MIN_LENGTH } from '../../../data-models/user-login';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [
    SharedModule,
    PasswordStrengthComponent
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent implements OnInit {
  token: any
  type: any
  isReset = false
  isGenerate = false
  isExpired = false
  isCompleted = false
  isCompletedGenerate = false

  lowerLetters = false
  upperLetters = false
  numbers = false
  symbols = false
  equals = false
  length = false
  id: any
  user: any

  resetForm: FormGroup | any;
  show = false;
  submmited = false;
  not_a_Player = true
  is_active = false;
  pwa_url: string = environment.pwa_url
  base_url: string = environment.base
  isResettingPassword: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private auth: AuthenticationService,
    private toastr: ToastrService,
    private loader : LoaderService
  ) { }


  ngOnInit(): void {
    this.loader.show();
    this.token = this.route.snapshot.paramMap.get('token')
    this.type = this.route.snapshot.paramMap.get('type')
    this.isReset = this.type.toLowerCase() === "reset"
    this.isGenerate = !this.isReset

    this.resetForm = new FormGroup({
      newpassword: new FormControl('', [Validators.required, Validators.minLength(PASSWORD_MIN_LENGTH)]),
      comfrimpassword: new FormControl('', [Validators.required, Validators.minLength(PASSWORD_MIN_LENGTH)]),
    })

    this.auth.verifyToken(this.token).subscribe({
      next: (res: any) => {
        if (res["token"] === "expired") {
          this.isExpired = true
          this.isReset = false
          this.isCompleted = false
          this.isGenerate = false
          this.loader.hide()
          this.toastr.error("This password reset link has expired.", 'Reset Link Expired', {
            progressBar: true,
            closeButton: true
          })
        } else {
          this.id = res['token']["Claims"]["id"]
          // console.log(res)
          if(res['token']["Claims"]["username"].length > 0){
            this.auth.fetchUserId(res['token']["Claims"]["username"]).subscribe({
              next: (res) => {
                this.id = res.id
                this.user = res
                this.not_a_Player = !(res.profile_type.some(e => e === 'Player' || e === "Parent"))
                if (!this.not_a_Player) {
                  const redirectUrl = `${this.pwa_url}user/reset/${this.token}/${this.type}`;
                  window.location.href = redirectUrl;
                  console.log(`Redirecting to: ${this.pwa_url}user/reset/${this.token}/${this.type}`);
                  this.loader.hide()
                  return
                }
                this.is_active = res.active_status === "active"
                // console.log(this.not_a_Player)
                this.loader.hide()
                this.toastr.success("Password link is active.", 'Link Active', {
                  progressBar: true,
                  closeButton: true
                })
              },
              error: (err) => this.handleInitError(err)
            });
          }else{
            this.auth.fetchUserData(this.id).subscribe({
              next: (res: any) => {
                this.loader.hide()
                this.user = res.data
                this.not_a_Player = !(res.data.profile_type.some((e: any) => e === 'Player' || e === "Parent"))
                this.is_active = res.data.active_status === "active"
                console.log(this.not_a_Player)
                this.toastr.success("Password link is active.", 'Link Active', {
                  progressBar: true,
                  closeButton: true
                })
              },
              error: (err) => this.handleInitError(err)
            });
          }
        }
      },
      error: (err) => this.handleInitError(err)
    })
  }

  /**
   * Handles a failure while verifying the reset/generate link on init.
   * Always hides the global loader (otherwise it spins forever), surfaces an
   * accurate network/server message, and falls back to the expired/recovery
   * view so the user is never left on a blank, frozen page.
   */
  private handleInitError(err: any) {
    this.loader.hide();
    this.isExpired = true;
    this.isReset = false;
    this.isGenerate = false;
    this.isCompleted = false;
    this.isCompletedGenerate = false;
    this.notifyNetworkOrServerError(err);
  }

  password() {
    this.show = !this.show;
  }

  @HostListener('window:offline')
  onOffline() {
    if (this.isResettingPassword) {
      this.isResettingPassword = false;
      this.toastr.error("No internet connection. Please check your network and try again.", 'No Internet', {
        progressBar: true,
        closeButton: true
      });
    }
  }

  @HostListener('window:online')
  onOnline() {
    this.toastr.success("You're back online. You can try again.", 'Connected', {
      progressBar: true,
      closeButton: true
    });
  }

  private notifyNetworkOrServerError(err: any) {
    if (!navigator.onLine || err?.status === 0) {
      this.toastr.error("No internet connection. Please check your network and try again.", 'No Internet', {
        progressBar: true,
        closeButton: true
      });
    } else {
      this.toastr.error("Something went wrong. Please try again.", 'Request Failed', {
        progressBar: true,
        closeButton: true
      });
    }
  }

  onLogin() {
    this.submmited = true
    if (this.isResettingPassword) {
      return;
    }
    if (!navigator.onLine) {
      this.toastr.error("No internet connection. Please check your network and try again.", 'No Internet', {
        progressBar: true,
        closeButton: true
      });
      return;
    }
    const isValid = this.checkStrength(this.resetForm.controls.newpassword.value, this.resetForm.controls.comfrimpassword.value)
    if (this.equals) {
      this.toastr.error("Passwords do not match.", 'Password Mismatch!', {
        progressBar: true,
        closeButton: true
      })
      return;
    }
    if (isValid) {
      this.isResettingPassword = true;
      if (this.is_active) {
        this.auth.changePasswordNotAcademy(this.id, this.resetForm.controls.newpassword.value).subscribe({
          next: () => {
            this.toastr.success("Your password has been changed successfully.", 'Password Changed', {
              progressBar: true,
              closeButton: true
            })
            if (this.isReset) {
              this.isExpired = false
              this.isReset = false
              this.isCompleted = true
              this.isCompletedGenerate = false
              this.isGenerate = false
              // console.log(`isRest not academy`)
            } else {
              this.isExpired = false
              this.isReset = false
              this.isCompleted = false
              this.isCompletedGenerate = true
              this.isGenerate = false
              // console.log(`notRest not academy`)
            }
            // console.log({
            //   isExpired: this.isExpired,
            //   isReset: this.isReset,
            //   isCompleted: this.isCompleted,
            //   isCompletedGenerate: this.isCompletedGenerate,
            //   isGenerate: this.isGenerate,
            // })
          },
          error: (err) => {
            console.error(err);
            this.notifyNetworkOrServerError(err);
            this.isResettingPassword = false;
          },
          complete: () => {
            this.isResettingPassword = false;
          }
        })
      } else {
        this.auth.changePassword(this.id, this.resetForm.controls.newpassword.value).subscribe({
          next: () => {
            this.toastr.success("Your password has been changed successfully.", 'Password Changed', {
              progressBar: true,
              closeButton: true
            })
            if (this.isReset) {
              this.isExpired = false
              this.isReset = false
              this.isCompleted = true
              this.isCompletedGenerate = true
              this.isGenerate = false
              // console.log(`isREst Academy`)
            } else {
              this.isExpired = false
              this.isReset = false
              this.isCompleted = false
              this.isCompletedGenerate = true
              this.isGenerate = false
              // console.log(`not reset Acaemdy`)
            }
            // console.log({
            //   isExpired: this.isExpired,
            //   isReset: this.isReset,
            //   isCompleted: this.isCompleted,
            //   isCompletedGenerate: this.isCompletedGenerate,
            //   isGenerate: this.isGenerate,
            // })
          },
          error: (err) => {
            console.error(err);
            this.notifyNetworkOrServerError(err);
            this.isResettingPassword = false;
          },
          complete: () => {
            this.isResettingPassword = false;
          }
        })
      }
    } else {
      this.toastr.error("Your password is not strong enough.", 'Weak Password!', {
        progressBar: true,
        closeButton: true
      })
    }
  }


  checkStrength(p: any, cp: any) {
    const regex = /[$-/:-?{-~!"^_@`[\]]/g;
    this.lowerLetters = /[a-z]+/.test(p);
    this.upperLetters = /[A-Z]+/.test(p);
    this.numbers = /[0-9]+/.test(p);
    this.symbols = regex.test(p);
    this.length = p.length >= PASSWORD_MIN_LENGTH
    this.equals = !(cp === p)
    return this.lowerLetters && this.upperLetters && this.numbers && this.symbols && this.length && !this.equals
  }
}
